export default __webpack_public_path__ + "static/media/James Thomas Davey - Resume.0733d59d.pdf";